import { IconHistory } from "@tabler/icons-react";
import { useEffect } from "react";
import { useGetApi } from "src/hooks";
import type { ISearchResult } from "src/pages/SearchPage/SearchPage.types";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setURNHistoryModalData } from "src/redux/slices/generatorFeaturesSlice";
import { StyledActionIcon } from "src/styled";
import { getYachtId } from "src/utils";
interface Props {
  urn: number;
  userName?: string;
}
const URNHistoryButton = ({ urn, userName }: Props) => {
  const dispatch = useDispatch();
  const { collectionId } = useSelector(state => state.generatorSlice);
  const { data, refetch, isLoading } = useGetApi<{
    success: boolean;
    data: ISearchResult[];
  }>({
    request: "search-urn-olb",
    fetchOnInit: false,
    body: {
      params: {
        urn: String(urn),
        colid: collectionId,
        yachtid: getYachtId(),
      },
    },
  });
  const handleOpen = () => {
    if (collectionId) void refetch();
  };
  useEffect(() => {
    if (data?.success) {
      dispatch(setURNHistoryModalData({ urn, userName, data: data.data }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [data]);
  if ((window.api && !window.navigator.onLine) || !urn) {
    return;
  }
  return (
    <StyledActionIcon onClick={handleOpen} loading={isLoading}>
      <IconHistory />
    </StyledActionIcon>
  );
};
export default URNHistoryButton;
